export default __webpack_public_path__ + "static/media/bg_outlet.cb1277dd.png";